// Shared trigger styling for the tool-call rows (ToolCallMessage) and the
// work-timeline rows (WorkBlock/) so they stay visually identical.
// -ml-3 cancels the trigger's own px-3 so the leading icon sits flush with
// the column edge — matches the ThinkingIndicator's brain icon.
export const TOOL_TRIGGER_CLASSNAME = [
  'group flex items-center gap-1.5 -ml-3 h-8 max-w-full px-3 py-2 rounded-lg',
  'text-sm font-medium text-primary-high-contrast leading-4 tracking-tight',
  'opacity-70 hover:opacity-100 data-[state=open]:opacity-100 cursor-pointer transition-opacity',
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-david-solid/30',
].join(' ')

export const TOOL_ICON_CLASSNAME = 'size-4.5 shrink-0'

export const TOOL_CHEVRON_CLASSNAME = `${TOOL_ICON_CLASSNAME} transition-transform group-data-[state=closed]:-rotate-90`

export const WORK_NEST_CLASSNAME =
  'ml-2 flex w-full flex-col border-l border-primary-high-contrast/10 pl-4 data-[state=closed]:animate-collapsible-up data-[state=open]:animate-collapsible-down'
